import { ReactComponent as AppStore } from '../../../../assets/images/mobile-markets/app-store.svg';
import { ReactComponent as GooglePlay } from '../../../../assets/images/mobile-markets/google-play.svg';
import { ReactComponent as RuStore } from '../../../../assets/images/mobile-markets/ru-store.svg';
import {
  APP_STORE_LINK_TEST_ID,
  ExternalLinks,
  GOOGLE_PLAY_LINK_TEST_ID,
  RU_STORE_LINK_TEST_ID,
} from '../../../../constants';

export const downloadAppLinks = [
  {
    id: 'appStore',
    href: ExternalLinks.mobileMarket,
    Icon: AppStore,
    testId: APP_STORE_LINK_TEST_ID,
  },
  {
    id: 'googlePlay',
    href: ExternalLinks.mobileMarket,
    Icon: GooglePlay,
    testId: GOOGLE_PLAY_LINK_TEST_ID,
  },
  {
    id: 'ruStore',
    href: ExternalLinks.ruStore,
    Icon: RuStore,
    testId: RU_STORE_LINK_TEST_ID,
  },
] as const;